import { Alert } from '@material-ui/lab';
import * as React from 'react';
import { Collapse, IconButton } from '@material-ui/core';
import MatrialCloseIcon from '@material-ui/icons/Close';
const styles = {
  mgb: {
    marginBottom: '10px'
  }
};
interface IAlertMessageprops {
  display: boolean;
  Message: string;
}
const AlertMessage = (props: any) => {
  return (
    <div style={styles.mgb}>
      {console.log(props.handleclose, 'fun')}
      <Collapse in={props.display}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={props.handleclose}
            >
              {props.handleclose ? <MatrialCloseIcon fontSize="inherit" /> : ''}
            </IconButton>
          }
          severity="error"
        >
          {props.Message}
        </Alert>
      </Collapse>
    </div>
  );
};
export default AlertMessage;
